import L, { point } from 'leaflet';
import { ReactNode } from 'react';
import MarkerClusterGroup from 'react-leaflet-cluster';
import ReactDOMServer from 'react-dom/server';

interface Props {
    children: ReactNode;
    color?: string; // Tailwind class or raw CSS value
}

export default function LeafLetCluster({ children, color = '#f75751' }: Props) {
    const createClusterCustomIcon = (cluster: any) => {
        const count = cluster.getChildCount();

        const htmlString = ReactDOMServer.renderToStaticMarkup(
            <div
                style={{ background: color }}
                className={` text-white size-8 rounded-full flex items-center 
          justify-center text-base font-semibold`}
            >
                {count}
            </div>
        );

        return new L.DivIcon({
            html: htmlString,
            className: 'custom-marker-cluster', // optional for extra styling
            iconSize: point(40, 40, true),
        });
    };

    return (
        <MarkerClusterGroup chunkedLoading iconCreateFunction={createClusterCustomIcon}>
            {children}
        </MarkerClusterGroup>
    );
}
